import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function AboutHero() {
  const titleRef = useScrollAnimation();
  const subtitleRef = useScrollAnimation();

  return (
    <section className="relative h-[50vh] flex items-center justify-center">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/15b1b97ba160c4a17a88d1e3bdf02182.jpg')`,
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 text-center px-6">
        <h1 
          ref={titleRef.ref}
          className={`font-serif text-5xl md:text-6xl font-bold text-white mb-6 transition-all duration-1000 ${
            titleRef.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          About Us
        </h1>
        <p 
          ref={subtitleRef.ref}
          className={`text-2xl text-white/90 max-w-3xl mx-auto transition-all duration-1000 delay-200 ${
            subtitleRef.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          Your Trusted Health Insurance Partner in Dallas
        </p>
      </div>
    </section>
  );
}
